import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { APIClient } from "../../helpers/api_helper";
import { Spinner } from "reactstrap";

const apiClient = new APIClient();

const formatAmount = (amount) => {
  if (amount == null || amount === "") return "0.00";
  const num = parseFloat(amount);
  return Number.isNaN(num)
    ? "0.00"
    : "₹" +
        num.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
};

const TopStock = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortBy, setSortBy] = useState("value");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await apiClient.get("/dashboard/top-stock", {
          sortBy,
          limit: 10,
        });
        const raw = response?.data ?? response;
        setData(Array.isArray(raw) ? raw : []);
      } catch (err) {
        setError(err?.message || "Failed to load top stock");
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [sortBy]);

  return (
    <Col xl={12}>
      <Card>
        <CardHeader className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Top Stock</h4>
          <div className="d-flex gap-1 flex-shrink-0">
            <button
              type="button"
              className={`btn btn-sm ${sortBy === "value" ? "btn-primary" : "btn-soft-secondary"}`}
              onClick={() => setSortBy("value")}
            >
              By Value
            </button>
            <button
              type="button"
              className={`btn btn-sm ${sortBy === "quantity" ? "btn-primary" : "btn-soft-secondary"}`}
              onClick={() => setSortBy("quantity")}
            >
              By Quantity
            </button>
          </div>
        </CardHeader>
        <CardBody>
          {loading ? (
            <div className="text-center py-5">
              <Spinner color="primary" />
            </div>
          ) : error ? (
            <div className="alert alert-danger mb-0">{error}</div>
          ) : (
            <div className="table-responsive table-card">
              <table className="table table-borderless table-centered align-middle table-nowrap mb-0">
                <thead className="text-muted table-light">
                  <tr>
                    <th scope="col">Product</th>
                    <th scope="col">Available Qty</th>
                    <th scope="col">Value</th>
                  </tr>
                </thead>
                <tbody>
                  {(data || []).map((row) => {
                    const name = row.fruitName ?? "—";
                    const subtype = row.subtypeName;
                    const productLabel = subtype ? `${name} (${subtype})` : name;
                    return (
                      <tr key={row.id}>
                        <td>
                          <span className="fw-medium text-body">{productLabel}</span>
                        </td>
                        <td>
                          {row.availableQuantity != null
                            ? Number(row.availableQuantity).toLocaleString()
                            : "—"}
                        </td>
                        <td>
                          <span className="text-success fw-medium">{formatAmount(row.value)}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default TopStock;
